import React from "react";
import { useSelector } from "react-redux";
import OfferItem from "./Item";
import BulkOfferClip from "../offers/bulkOfferClip";
import "./offersV2.scss";
import { useParams } from "react-router-dom";

const OffersV2 = (props) => {
  const params = useParams();
  const siteConfig = props.page
  const offerBlock = siteConfig.components.find(component => component.block_type === 'OfferBlock');
  let isLoading = !params.id ? false : true,
    queryId = params ? params.id : false,
    deepLinkOffer = params.id ? findOffer(params.id) : "";
  let available = useSelector((state) => state.offer.collections.available);
  let featured = useSelector((state) => state.offer.collections.featured);
  let links = siteConfig.colorLinks;
  const isMobileTwoColumns = offerBlock.use_two_column_mobile;

  function findOffer (id) {
    let deepLinkOffer = available.find(
      (cpn) => cpn.mdid === parseInt(id)
    );
    isLoading = false;
    return deepLinkOffer;
  }

  function RenderDeepLink (props) {
    const { cpn } = props;
    return (
      <div>
        <div className="SingleOffer">
          <OfferItem coupon={cpn} key={cpn.mdid} page={siteConfig} />
        </div>
      </div>
    );
  }

  function RenderOfferList (props) {
    return (
      <div className="offerContent2">
        <div className="tw-w-full tw-max-w-[1440px] tw-mx-auto tw-px-4 tw-py-8 tw-flex tw-flex-col tw-justify-start tw-items-center tw-gap-4">
          <div className="tw-text-center tw-text-zinc-800 tw-text-4xl tw-font-extrabold tw-font-['Switzer Variable'] tw-leading-tight sm:tw-text-5xl md:tw-text-6xl lg:tw-text-7xl">{offerBlock.coupon_title_text ? <p>{offerBlock.coupon_title_text}</p> : <p>In Store Digital Coupons</p>} </div>
          <div className="tw-w-full tw-max-w-[680px] tw-text-center tw-text-zinc-800 tw-text-base tw-font-normal tw-font-['Switzer Variable'] tw-leading-snug sm:tw-text-lg md:tw-text-xl">{offerBlock.coupon_subtitle_text ? <p>{offerBlock.coupon_subtitle_text}</p> : <p>Your Publix savings journey starts here – clip coupons to use in-store!</p>}</div>
          {/* <div className="w-full max-w-[680px] text-center text-zinc-800 text-base font-bold font-['Switzer Variable'] underline leading-snug sm:text-lg md:text-xl">Become a Club Publix Member today!</div> */}
        </div>
        {offerBlock && offerBlock.use_bulk_offer_clip && (
          <BulkOfferClip siteConfig={siteConfig} />
        )}
        <div className={`OfferList ${isMobileTwoColumns ? 'mobile-two-columns' : ''}`}>
          {props.available.map((cpn) => {
            return <OfferItem coupon={cpn} key={cpn.mdid} page={props.page} isMobileTwoColumns={isMobileTwoColumns} />;
          })}
        </div>
      </div>
    );
  }

  function RenderFeaturedList(props) {
    return (
      <div className="FeaturedOfferList">
        {props.featured.map((cpn) => {
          return <OfferItem coupon={cpn} key={cpn.mdid} isFeatured={true} page={props.page} />;
        })}
      </div>
    );
  }

  function trackViewMoreEvent (){
    window.gtag('event', 'View More Coupons', { 
      retailer_id: "Publix",
      version: localStorage.getItem("AB_TEST_VARIABLE") || 'N/A'
    });
  }

  if (isLoading) {
    return "";
  }

  //displays offer-section of page
  if (queryId && deepLinkOffer) {
    return <RenderDeepLink cpn={deepLinkOffer} page={siteConfig} />;
  } else if (!queryId && (available.length > 0 || featured.length > 0)) {
    return (
      <div className="offer-section" style={{ color: links, paddingBottom: "1%" }}>
        {featured.length > 0 && <RenderFeaturedList featured={featured} page={siteConfig} />}
        <RenderOfferList available={available} page={siteConfig} />
        <br></br>
        {offerBlock && offerBlock.show_view_more_coupons && (
        <a
          className="viewMore"
          href="https://www.publix.com/savings/digital-coupons"
          onClick={trackViewMoreEvent}
          style={{ color: links }}
        >
          View more Publix digital coupons...
        </a>
      )}
      </div>
    );
  } else {
    return (
      <div className="offer-section">
        <p>There are no available offers</p>
      </div>
    );
  }
};

export default OffersV2;
